import script from "./DetailSearchInvoiceNonProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailSearchInvoiceNonProxy.vue?vue&type=script&setup=true&lang=js"

import "./DetailSearchInvoiceNonProxy.vue?vue&type=style&index=0&id=0296f7fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0296f7fe"]])

export default __exports__